import { initAll, setGroup, setUserId, track } from '@amplitude/unified'
import { Environment, getEnvironment } from '@backoffice-frontend/environment'

const AMPLITUDE_API_KEY = 'c7550f5d69449204fd58db0469a8cb75'

let initialized = false

export const initAnalytics = () => {
  if (initialized) return
  initialized = true

  if (getEnvironment() !== Environment.production) return
  if (window.location.hostname === 'localhost') return

  initAll(AMPLITUDE_API_KEY, {
    serverZone: 'EU',
    analytics: {
      autocapture: {
        elementInteractions: false,
        formInteractions: false,
        fileDownloads: false,
      },
    },
  })
}

export const identifyAnalyticsUser = (userId: string, organization: string) => {
  setUserId(userId)
  setGroup('organization', organization)
}

/**
 * Track a custom Amplitude event.
 *
 * Event names use "Object Action" format in title case (e.g. "Alert Resolved", "Vehicle State Changed").
 * Properties use camelCase. Never include PII (names, emails, phone numbers).
 *
 * @see docs/guides/tracking.md
 */
export const trackEvent = (
  name: string,
  properties?: Record<string, string | number | boolean>,
) => {
  track(name, properties)
}

type TrackingProps = {
  action?: string
  category?: string
  label?: string
  value?: number
}

/** @deprecated Use {@link trackEvent} instead. See docs/guides/tracking.md. */
export const trackAnalyticsEvent = (_props: TrackingProps) => {}

/** @deprecated Use {@link trackEvent} instead. See docs/guides/tracking.md. */
export const trackClickEvent = (_label: string) => {}

/** @deprecated Use {@link trackEvent} instead. See docs/guides/tracking.md. */
export const useImpressionTracking = (
  _props: Omit<TrackingProps, 'action'>,
) => {}
